import {ErrorTags, EventNames} from '../../lib/analytics/events';
import Tracker from '../../lib/analytics/tracker';

class WrappedError extends Error {
    constructor(
        message: string,
        public originalError: Error | any,
    ) {
        super(message);
    }
}

export async function trackFn<T>(fn: () => Promise<T>, eventName?: EventNames, errorTag?: ErrorTags): Promise<T> {
    try {
        let response = await fn();
        if (eventName) Tracker.trackEvent(eventName);
        return response;
    } catch (e) {
        if (errorTag) {
            if (e instanceof Error) {
                Tracker.trackError(e, errorTag);
            } else {
                // let us hope e is serializable
                Tracker.trackError(new WrappedError('Non-Error thrown', e), errorTag);
            }
        } else {
            console.error('Error occurred in trackRequest, but no errorTag was provided', e);
        }
        throw e;
    }
}

export async function trackPromise<T>(promise: Promise<T>, eventName?: EventNames, errorTag?: ErrorTags): Promise<T> {
    return trackFn(() => promise, eventName, errorTag);
}
